import { render, staticRenderFns } from "./GraphDetail46.vue?vue&type=template&id=4c87c4f6&scoped=true"
import script from "./GraphDetail46.vue?vue&type=script&lang=js"
export * from "./GraphDetail46.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87c4f6",
  null
  
)

export default component.exports